/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useState, useRef} from "react";
import { selectTreeMeans, navigationTreePC, urlMeans } from '../actions/proyects.actions';
import {alpha, makeStyles, withStyles} from "@material-ui/core/styles";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import {useHistory} from "react-router-dom";
import subprojectIcon from '../assets/img/icons/subproject.png';
import projectIcon from '../assets/img/icons/project.png';
// import subprojectIcon_none from '../assets/img/icons/subproject_none.png';
// import projectIcon_none from '../assets/img/icons/project_none.png';

import {useSelector, useDispatch} from "react-redux";

function MinusSquare(props) {
	return (
		<div className="d-flex">
			<ion-icon name="chevron-down-outline"></ion-icon>
			<img src={projectIcon} alt="icons" width="15" style={{ marginRight: 8}} {...props}/>
		</div>
	);
}

function PlusSquare(props) {
	return (
		<div className="d-flex">
			<ion-icon name="chevron-forward-outline"></ion-icon>
			<img src={projectIcon} alt="icons" width="15" style={{ marginRight: 8}} {...props}/>
			
		</div>
	);
}

function CloseSquare(props) {
	return (
		<img src={subprojectIcon} width="15" alt="icons" style={{ marginRight: 8}} {...props}/>
	);
}

const StyledTreeItem = withStyles((theme) => ({
	iconContainer: {
		"& .close": {
			opacity: 0.3,
		},
	},
	group: {
		marginLeft: 7,
		paddingLeft: 18,
		borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
	},
}))((props) => <TreeItem {...props} />);

const useStyles = makeStyles({
	root: {
		height: 264,
		flexGrow: 1,
		maxWidth: 400,
	},
});

const TreeMeans = ({ idProject, urlPrefix, idMeans, data = {}, onSelectItem, refresh, setChanges }) => {

	let history = useHistory();
	const classes = useStyles();
	const dispatch = useDispatch();
	// eslint-disable-next-line
	const [loading, setLoading] = useState(false);

	const proyects = useSelector((state) => state.proyects);
	const [nodeRequested, setNodeRequested] = useState({})
	const [search, setSearch] = useState();
	const [ itemSelected, setItemSelected ] = useState('')
	const [myTimer, setMyTimer] = useState();
	
	// useEffect(() => {
	// 	async function init() {
	// 		// dispatch(classificationData(idProject));
	// 		setLoading(false);
	// 	}
	// 	init()
	// 	// eslint-disable-next-line
	// },[type]);

	useEffect(() => {
		if(data.length === 0) {
			setNodeRequested({});
		}
	}, [data])

	const refNodeRequested = useRef([]);
	useEffect(() => {
		refNodeRequested.current = nodeRequested;
	}, [nodeRequested])

	useEffect(() => {
		if( search === '' || (search && search.length >= 3) ) {
			if (myTimer) clearTimeout(myTimer);
			setNodeRequested({});
			const newTimer = setTimeout(() => {
				console.log('aqui')
				if (myTimer) clearTimeout(myTimer);
				setChanges('', 1, search, true);
			}, 1200);
			setMyTimer(newTimer);
		}
	}, [search]);
	
		
	const changeItem = (pc, newTitle) => {
		
		if (itemSelected === pc.CodInsumo) return;
		if(onSelectItem) onSelectItem(pc);
		setItemSelected(pc.CodInsumo);
		// dispatch(navigationTreePC(newTitle))
		history.push(`${urlPrefix}${pc.CodInsumo}`)
		// console.log('el id de este item es ', filter.CodInsumo, proyects.idCard)
	}

	const drawerItems2 = (codInsumo, nivel) => {
		if ( !data || (!data[codInsumo] && nivel > 4) ) return '';
		if (!data[codInsumo]) {
			return (
				<StyledTreeItem
					key={`key-${codInsumo}-loading`}
					nodeId={`key-${codInsumo}-loading`}
					label="Cargando..."
				>
				</StyledTreeItem>
			);
		}
		return data[codInsumo].map((item) => {
			return (
				<StyledTreeItem
					key={`key-${item.CodInsumo}.`}
					nodeId={item.CodInsumo}
					label={item.Descripcion}
					// hidden={ item.hidden }
					// className={item.Nivel < 4 || item.TieneDato === 1 ? '' : 'nohay'}
					onIconClick={() => {
						if (setChanges && !refNodeRequested.current[item.CodInsumo]) {
							setChanges(item.CodInsumo, (item.Nivel + 1), search);
							let currentRequest = refNodeRequested.current;
							currentRequest[item.CodInsumo] = item.CodInsumo;
							setNodeRequested(currentRequest);
						}
						dispatch(selectTreeMeans(item.CodInsumo));
					}}
					onLabelClick={ () => {
						changeItem(item, item['breadcrums'])
						dispatch(
							navigationTreePC(
								`${item.breadcrumbs}`
							)
						);
						dispatch(urlMeans(`${urlPrefix}${item.CodInsumo}`))
					}}
					
				>
					{ drawerItems2(item.CodInsumo, item.Nivel) }
				</StyledTreeItem>
			);
		});
	}

	return (
		<>
			<div className="input-group mb-2">
				<div className="input-group-prepend">
					<div className="input-group-text" id="btnGroupAddon">
						<i className="fas fa-search"></i>
					</div>
				</div>
				<input
					type="search"
					className="form-control"
					placeholder="Buscador..."
					aria-label="Input group example"
					aria-describedby="btnGroupAddon"
					onChange={({target}) => setSearch(target.value)}
				/>
			</div>

			<TreeView
				className={classes.root}
				// defaultExpanded={["1"]}
				defaultCollapseIcon={<MinusSquare />}
				defaultExpandIcon={<PlusSquare />}
				defaultEndIcon={<CloseSquare />}
				expanded={proyects.treeSelectedsMeans} // estas usando el tree sleecteds de PC
				selected={idMeans}
				// className="mb-5"
			>
			
			{
				loading ? 'Cargando...' : 
				drawerItems2('Level1', 1)
				
			}
			</TreeView>
		</>
	);
}

export default TreeMeans
